
<p-inputNumber [placeholder]="placeholder" [required]="required" (onInput)="onValueChange($event)"
  (onFocus)="onFocus()" (onBlur)="onBlur()" [mode]="mode" [maxlength]="maxLength" [max]="maxValue"
  [min]="0" [minFractionDigits]="2"  [(ngModel)]="value"/>
  @if (touched && isRequiredAndEmpty) {
    <p class="error">{{ errorMessage }}</p>
  }
